// extracted by mini-css-extract-plugin
export default {"label":"FormInputNumeric_label__Mt44J"};